module.exports = __webpack_public_path__ + "static/media/mc_elo.05da307b.svg";